module.exports = __webpack_public_path__ + "static/media/icon_product_sell.1cc5688a.svg";